import { makeStyles } from '@material-ui/core';
import { black } from '../../../abstracts/colours';
import { fonts } from '../../../abstracts/constants';

const useStyles = makeStyles({
  arrow: {
    color: black,
  },
  tooltip: {
    fontFamily: fonts.sourceSansPro,
    backgroundColor: black,
    fontSize: '14px',
    borderRadius: '5px',
    padding: '8px',
  },
});

export default useStyles;
